import { render, staticRenderFns } from "./NuevoEmpleado.vue?vue&type=template&id=3d6409b4"
import script from "./NuevoEmpleado.vue?vue&type=script&lang=js"
export * from "./NuevoEmpleado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports